// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Component
const InsuranceBillSvg = ({ color, height, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 31 42"
    role="presentation"
  >
    <g fill={color} fillRule="evenodd" stroke="#FCFBFC" strokeWidth="0.3">
      <path d="M25.708 1h-7.562a1.07 1.07 0 00-1.065 1.07v.535H2.066A1.07 1.07 0 001 3.675v36.162c0 .59.48 1.07 1.065 1.07h27.317a1.07 1.07 0 001.065-1.07V3.675c0-.59-.48-1.07-1.065-1.07H26.72V2.07c.053-.59-.426-1.07-1.012-1.07zM19.21 3.14h5.433v8.398l-2.024-1.444a1.037 1.037 0 00-1.225 0l-2.184 1.498V3.14zm9.16 1.605v34.022H3.13V4.745h13.95v8.826c0 .376.214.75.587.964.373.16.746.16 1.118-.053l3.25-2.193 3.087 2.194c.16.108.373.215.586.215.16 0 .32-.054.48-.107.372-.16.585-.535.585-.963v-8.88h1.597z" />
      <path d="M6.065 14.14h6.816a1.071 1.071 0 00.001-2.14H6.066a1.07 1.07 0 00-.001 2.14zM24.702 19H6.065a1.07 1.07 0 000 2.14h18.637a1.07 1.07 0 000-2.14zm0 3H6.065a1.07 1.07 0 000 2.14h18.637a1.07 1.07 0 000-2.14zm-6.442 4H6.064a1.07 1.07 0 00.001 2.14H18.26a1.07 1.07 0 00-.001-2.14z" />
    </g>
  </svg>
);

InsuranceBillSvg.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};
export default InsuranceBillSvg;
